export default __webpack_public_path__ + "media/images/archetypes/booster-ff9549194410793ae926b43449d06a5a.png";